export default __webpack_public_path__ + "static/media/element_spec_46.047107ae.webp";